<template>
  <v-tab @click="click">{{title}} &nbsp;
      <slot></slot>
  </v-tab>
</template>

<script>
export default {
    name: "PsTab",
    props: {
        title: "",
        active: {
            type: Boolean,
            required: false,
            default: false
        },
        click: {
            type: Function,
            required: false,
            default: () => {  }
        }
    },
    data() {
        return {

        };
    }
};
</script>